(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["v5-produktsakerhet"] && !Shopify.designMode) return;
  try {
    /* Byter artikelnumret när kunden väljer en annan variant (samma händelse som skärdatatabellen lyssnar på). */
  if (!customElements.get('v5-produktsakerhet')) {
    customElements.define(
      'v5-produktsakerhet',
      class extends HTMLElement {
        connectedCallback() {
          this.sektion = this.closest('.shopify-section, dialog');
          this.sektion?.addEventListener('variant:update', this.uppdatera);
        }

        disconnectedCallback() {
          this.sektion?.removeEventListener('variant:update', this.uppdatera);
        }

        uppdatera = (event) => {
          const ny = event.detail?.data?.html?.querySelector('v5-produktsakerhet [data-v5-ps-artnr]');
          const nu = this.querySelector('[data-v5-ps-artnr]');
          if (ny && nu) nu.replaceWith(ny);
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
